module.exports = __webpack_public_path__ + "img/rainy.2bd23641.svg";